import { DriveFile } from '@/modules/drive/domain/models/DriveFile'

import { axios, Response } from '../index'

export default async function updateFileName(
  fileId: string,
  name: string
): Response<DriveFile> {
  return await axios.put(`/v1/files/${fileId}`, { name })
}
